import createPseudoHook from "../createPseudoHook";
export var useActive = createPseudoHook({
  events: ['mousedown', 'mouseup']
});
export var useFocus = createPseudoHook({
  events: ['focus', 'blur']
});
export var useHover = createPseudoHook({
  events: ['mouseenter', 'mouseleave']
});
export { default as useDimensions } from "./useDimensions";
export { default as useScaledSize } from "./useScaledSize";
export { default as useLayout } from "./useLayout";
export { default as useREM } from "./useREM";